import React from 'react';
import PropTypes from 'prop-types';

import Tree from 'rc-tree';
import 'rc-tree/assets/index.css';

import useTree from '@ecp/common/src/components/unstyled/tree/useTree';

const TreeUnstyled = ({
  rootComponent: Root,
  wrapperComponent: Wrapper,
  treeNodeComponent: TreeNode,
  searchKeyword,
  ...props
}) => {
  const { getRootProps, getTreeProps, getTreeNodeProps } = useTree(props);
  const { rootless } = props;

  return (
    <Root width={'100%'} height={'100%'} {...getRootProps()}>
      <Wrapper rootless={rootless}>
        <Tree
          {...getTreeProps()}
          icon={(props) => <TreeNode searchKeyword={searchKeyword} {...props} {...getTreeNodeProps()} />}
        />
      </Wrapper>
    </Root>
  );
};

TreeUnstyled.displayName = 'TreeUnstyled';

TreeUnstyled.propTypes = {
  rootComponent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element, PropTypes.node]),
  wrapperComponent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element, PropTypes.node]),
  treeNodeComponent: PropTypes.oneOfType([PropTypes.elementType, PropTypes.element, PropTypes.node]),
  treeNodeProps: PropTypes.object,
  data: PropTypes.array,
  editable: PropTypes.bool,
  searchKeyword: PropTypes.string,
  rootless: PropTypes.bool,
  rootUnchangeable: PropTypes.bool,
};

TreeUnstyled.defaultProps = {
  rootComponent: 'div',
  wrapperComponent: 'div',
  editable: false,
  rootless: false,
  rootUnchangeable: false,
};

export default TreeUnstyled;
